import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { ErrorInfo, ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

import { ErrorBoundaryFallback } from './';

type Props = {
    children: ReactNode;
    reactPlugin: ReactPlugin;
};

export const DefaultErrorBoundary = ({ children, reactPlugin }: Props) => {
    const location = useLocation();

    const handleError = (error: unknown, errorInfo: ErrorInfo) => {
        const err = error as Error;
        reactPlugin
            && reactPlugin?.trackException({
                error: err,
                exception: err,
                severityLevel: SeverityLevel.Error,
                properties: errorInfo,
            });
    };

    return (
        <ErrorBoundary key={location.pathname} FallbackComponent={ErrorBoundaryFallback} onError={handleError}>
            {children}
        </ErrorBoundary>
    );
};
